import { Box } from '@chakra-ui/react'

export const VirtualScrollBar = () => {
  return (
    <Box
      sx={{
        display: { base: 'none', md: 'block' },
        width: '3px',
        height: '100%', // 8px is the top margin of the line
        bg: 'white',
        ml: '-3px',
        mt: 8,
        borderRadius: 'full',
      }}
    />
  )
}
